export const STREAM_AD_OFFSET = 4; // NOTE: adjusting this value will also require CSS updates
// MOBILE
export const IN_POST_AD_FIRST_OFFSET_MOBILE = 2; // The offset of the first ad (relative to media items)
export const IN_POST_AD_OFFSET_MOBILE = 3; // The offset of subsequent ads (relative to media items)
// DESKTOP
export const IN_POST_AD_FIRST_OFFSET_DESKTOP = 3; // The offset of the first ad (relative to media items)
export const IN_POST_AD_OFFSET_DESKTOP = 4; // The offset of subsequent ads (relative to media items)

export const GALLERY_AD_OFFSET_AMP = 4;
